import {create} from "zustand";
import {persist} from "zustand/middleware";

import {Property} from "@/src/modules/properties/types";

import {zustandPersistStorage} from "../lib/zustand-custom-store";

type UserPropertyStore = {
  userProperty: Property | null;
  setUserProperty: (userProperty: Property | null) => void;
  clearUserProperty: () => void;
};

export const useUserPropertyStore = create<UserPropertyStore>()(
  persist(
    (set) => ({
      userProperty: null,

      setUserProperty: (userProperty: Property | null) => {
        set({userProperty});
      },

      clearUserProperty: () => {
        set({userProperty: null});
      },
    }),
    {
      name: "user-property-store",
      storage: zustandPersistStorage,
      partialize: (state) => {
        return {userProperty: state.userProperty};
      },
      merge: (persistedState: any, currentState: any) => ({
        ...currentState,
        ...persistedState,
      }),
    },
  ),
);

export function useStoredUserProperty() {
  return useUserPropertyStore((state) => state.userProperty);
}
